import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import OrderAddressText from './OrderAddressText';

export default function OrderMemoInput({ memo, disabled = false, onCommit }: {
  memo: string; disabled?: boolean; onCommit: (value: string) => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  const [text, setText] = useState(memo);
  useEffect(() => {
    if (document.activeElement !== input.current) setText(input.current?.value ?? memo);
  }, [memo]);
  return <OrderAddressText address={text} overflowTarget={input} focusable={false}>
    <Input ref={input} defaultValue={memo} aria-label="주문 메모" placeholder="내용을 입력해주세요." disabled={disabled}
      onChange={event => setText(event.target.value)} onBlur={event => {
        if (event.target.value !== memo) onCommit(event.target.value);
      }} />
  </OrderAddressText>;
}
const Input = styled.input`
  display:block; width:100%; max-width:100%; min-width:0; min-height:var(--control-sm); box-sizing:border-box;
  border:0; background:transparent; color:var(--color-text-primary); text-align:center;
  padding:0 var(--space-2); font:inherit; font-size:var(--text-caption); overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
  &:focus { outline:2px solid var(--color-focus-ring); outline-offset:-2px; background:var(--color-bg-muted); border-radius:var(--radius-sm); }
  &:disabled { color:var(--color-text-disabled); cursor:not-allowed; }
`;
